// Screen: "Game Table"
import React from 'react';
import BuckEuchre from '../BuckEuchre';

export default function GamePage() {
  return <BuckEuchre />;
}
